/*
 * @Author: AllezLRC 13636411941@163.com
 * @Date: 2025-03-30 08:39:11
 * @LastEditors: AllezLRC 13636411941@163.com
 * @LastEditTime: 2025-03-30 09:24:24
 * @FilePath: /wemeet-admin-new/src/views/recruitment/hooks/useTags.js
 * @Description:
 * Copyright (c) 2025 by WeMeet, All Rights Reserved.
 */
import { ref, computed } from 'vue'
import { useGlobalConfig } from '@/hooks/useGlobalConfig'

export function useTags() {
  const tagKey = 'recruitmentTalentTag'
  const tagOptions = ref([])
  const tagCN = computed(() => Object.fromEntries(tagOptions.value.map(({ id, name }) => [id, name])))

  useGlobalConfig(tagKey, (val) => (tagOptions.value = val))

  return {
    tagCN,
    tagOptions,
  }
}
